import { createContext } from "react";
import type { I18nInstance } from "../types";

export const I18nContext = createContext<I18nInstance | null>(null);
